/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import * as types from '../actions/actionTypes';


const initialState = window.selectedPuff ? window.selectedPuff : {selectedPuff:{id:0, puff:null, options:null}}


if(window.search && initialState.selectedPuff.puff){
  initialState.selectedPuff.puff.tabId = 'search'
}

const puff = function(state = initialState, action) {
  const {id, puff, options, body, response, error} = action

  switch(action.type) {
    // case types.SAVEPUFF_FAILURE:
    //   console.log('THIS HAPPENED')
    //   return state;
    case types.SET_FOCUSED_PUFF:
      return {...state,
      	selectedPuff:{
      		...state.selectedPuff,
      		id,
      		puff,
          options
      	}
      }
    case types.SAVEPUFF_SUCCESS:
      if(state.selectedPuff && state.selectedPuff.puff){
        return {
          ...state,
          selectedPuff:{
            ...state.selectedPuff,
            puff:{...state.selectedPuff.puff,...body.puff}
          }
        }
      }
      return state;
      
    case types.ORDERPUFF_FAILURE:
      // console.log('FAAAAAAAAAAAAAILEEED')
      // console.log(response)
      // console.log(error)
      // console.log(action)
      let res = null
      try{
        res = error ? JSON.parse(error) : null
      }catch(e){
        
      }
      if(state.selectedPuff && state.selectedPuff.puff && res && res.status==='fail'){
        return {
          ...state,
          selectedPuff:{
            ...state.selectedPuff,
            puff:{...state.selectedPuff.puff,...{status:res.currentStatus, msg:res.msg, loading:false}}
          }
        }
      }
      return state;
    case types.ORDERPUFF_SUCCESS:
      if(state.selectedPuff && state.selectedPuff.puff && response.status==='success'){
        return {
          ...state,
          selectedPuff:{
            ...state.selectedPuff,
            puff:{...state.selectedPuff.puff,
                  ...{status:response.newStatus ? response.newStatus : body.status, loading:false},
                 ...(response.newStatus && response.newStatus.type==='assigning' ? {purchased:new Date(), locked:false} : {})
                }
          }
        }
      }
      return state;
      
      // if(body.id && response.status==='success'){
      //   return setPuff(state, {feed:{id:body.options.feed.id}, puff:{id:body.options.puff.id}, partial:{status:body.status}})
      // }
      // return state;

  }

  return state;

}

export default puff;


